import React, { useState, useEffect } from 'react';
import Axios from 'axios';
import { useParams } from 'react-router-dom'

import ProgressIndicator from '../../Common/ProgressIndicator';
import ErrorIndicator from '../../Common/ErrorIndicator';

import PageEditForm from './PageEditForm';


function PageEditPage(props) {
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(false);
    const [page, setPage] = useState(null);
    const { id } = useParams();

    useEffect(() => {
        setIsLoading(true);
        Axios.get(`/admin/pages/${id}`).then(res => {
            setPage(res);
            setIsLoading(false);
        }, err => {
            setIsLoading(false);
            setError(true);
        });
    }, [id]);

    if (isLoading)
        return <ProgressIndicator />;

    if (error)
        return <ErrorIndicator text="A lap letöltése sikertelen." />;

    if (page)
        return (
            <>
                <h1>Lap szerkesztése</h1>
                <PageEditForm page={page} />
            </>
        );

    return null;
}

export default PageEditPage;
